import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Team from './pages/Team';
import Socials from './pages/Socials';
import Charity from './pages/Charity';
import Events from './pages/Events';
import NewEditor from './pages/NewEditor';
import FullEditor from './pages/FullEditor';
import './App.css';

function App() {
  const location = useLocation();
  const isEditorPage = location.pathname.startsWith('/manage');

  return (
    <div className="App">
      {!isEditorPage && <Navbar />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/team" element={<Team />} />
          <Route path="/socials" element={<Socials />} />
          <Route path="/charity" element={<Charity />} />
          <Route path="/events" element={<Events />} />
          <Route path="/manage" element={<NewEditor />} />
          <Route path="/manage/legacy" element={<FullEditor />} />
        </Routes>
      </main>
      {!isEditorPage && <Footer />}
    </div>
  );
}

export default App;